const hiddenClass = 'v2-hidden';
export const hideElement = element => element && element.classList.add(hiddenClass);
export const showElement = element => element && element.classList.remove(hiddenClass);
